import SignInForm from './components/SignInForm';
import SignupList from './components/SignupList';
import Guidelines from './components/Guidelines';

function App() {
	return (
		<div className="pageDiv">
			<div className="SignupDiv">
				<h1>Current Projects</h1>
				<p className='explain'>Listed below are our current projects that need volunteers.</p>
				<p className='explain'>Please read the card guidelines to the right and then pick the project 
				you would like to help us with. <b>We ask our volunteers to create a minimum of ten cards 
				but you can choose to do more.</b> If you are a large group and need a bigger project then listed 
				contact us.</p>
				<p className='explain'>The deadline listed is the date our offices need to receive the cards 
				by so plan accordingly and plan for shipping time. Cards should be shipped to our 
				corporate office 
				at 44573 Yarmouth Dr, Ashburn VA 20147.</p>
				<p className='explain'>If you need assistance contact  
				<a href="mailto://request@abrightspot.org">request@abrightspot.org</a>.</p>
				<p className='explain'>You can save your information by signing up to make cards and 
				clicking on the "Save my information for next time" button.</p>
				<SignupList />
			</div>
			<div className="explainContainer">
				<SignInForm />
				<Guidelines />
			</div>
		</div>
	)
}

export default App;
